<template>

 <div class="md:flex md:items-center mb-6">
    <label>Repo</label>
    <ul>
      <li v-for="repo in repos" :key="repo.id" @click="$emit('select', repo)">{{ repo.name }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SelectRepository',
  computed: {
    repos () {
      return this.$store.state.repos
    }
  },
  created () {
    this.$store.dispatch('getRepos')
  }
}
</script>

<style>

</style>
